/* eslint-disable func-names */
//import initKlaro from './components/klaro';
import initSharer from './components/share';
import skipLinkFocusFix from './components/skip-link-focus-fix';
import * as Klaro from 'klaro/dist/klaro-no-css';

skipLinkFocusFix();

//Init cookie consent management
if ( typeof ewData == 'object' && Object.hasOwn(ewData, 'klaroConfig') ) {
	//window.klaroConfig = ewData.klaroConfig;
	window.klaro = Klaro;
	Klaro.setup( ewData.klaroConfig );

	const klaroTriggers = document.querySelectorAll( '.js-klaro-modal-trigger' );
	if ( klaroTriggers ) {
		klaroTriggers.forEach( i => {
			i.addEventListener( 'click', ( e ) => {
				e.preventDefault();
				window.klaro.show( window.klaroConfig, true );
			}
			);
		} );
	}
}

  // Share functionality
const shareItems = document.querySelectorAll('.js-social-share');
if (shareItems) {
  shareItems.forEach(element => {
    initSharer(element);
  });
}
